import type { GlobalState, TabState } from '../types';

import { cloneDeep } from '../../util/iteratees';
import { INITIAL_TAB_STATE } from '../initialState';

export function createInitialTabState<T extends GlobalState>(
  global: T,
  tabId: number,
  isMasterTab = false,
): TabState {
  const initialTabState = cloneDeep(INITIAL_TAB_STATE);

  initialTabState.id = tabId;
  initialTabState.isMasterTab = isMasterTab;
  if (global.audioPlayer) {
    initialTabState.audioPlayer.playbackRate = global.audioPlayer.lastPlaybackRate;
    initialTabState.audioPlayer.isPlaybackRateActive = global.audioPlayer.isLastPlaybackRateActive;
  }
  if (global.mediaViewer) {
    initialTabState.mediaViewer.playbackRate = global.mediaViewer.lastPlaybackRate;
  }

  if (global.lastIsChatInfoShown) {
    initialTabState.chatInfo = {
      isOpen: true,
    };
  }

  return initialTabState;
}

export function ensureTabState<T extends GlobalState>(
  global: T,
  tabId: number,
  isMasterTab = false,
): T {
  const byTabId = global.byTabId || {};

  if (byTabId[tabId]) {
    return global;
  }

  return {
    ...global,
    byTabId: {
      ...byTabId,
      [tabId]: createInitialTabState(global, tabId, isMasterTab),
    },
  };
}
